import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27f06c20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-login" }
const _hoisted_2 = { id: "wrapper1" }
const _hoisted_3 = { class: "com_login1" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "copy1" }, null, -1))
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "form1" }
const _hoisted_8 = { class: "group1" }
const _hoisted_9 = { class: "ch_input_password1" }
const _hoisted_10 = ["type"]
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 0,
  class: "error-message"
}
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "com_link_list1" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "copyright1" }, "© 2025 Kaunet", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _hoisted_4,
          _createElementVNode("img", {
            src: _ctx.loginImage,
            alt: "",
            class: "image1"
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("img", {
            src: _ctx.loginLogoImage,
            alt: _ctx.altText,
            class: "id1"
          }, null, 8, _hoisted_6),
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              id: "loginId",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loginId) = $event)),
              type: "text",
              placeholder: "ログインID",
              maxlength: "255"
            }, null, 512), [
              [_vModelText, _ctx.loginId]
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _withDirectives(_createElementVNode("input", {
                  type: _ctx.isPasswordVisible ? 'text' : 'password',
                  placeholder: "パスワード",
                  id: "newPassword",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                  maxlength: "255"
                }, null, 8, _hoisted_10), [
                  [_vModelDynamic, _ctx.password]
                ]),
                _createElementVNode("img", {
                  class: "pwdIcon",
                  src: _ctx.currentPassworIcon,
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.togglePasswordVisibility && _ctx.togglePasswordVisibility(...args)))
                }, null, 8, _hoisted_11)
              ])
            ]),
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "submit",
              id: "btnLogin",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args))),
              disabled: _ctx.isProcessing
            }, " ログイン ", 8, _hoisted_13)
          ]),
          _createElementVNode("ul", _hoisted_14, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/password-reset",
                class: "com_link1",
                disabled: _ctx.isProcessing
              }, {
                default: _withCtx(() => [
                  _createTextVNode("初回ログイン時、またはパスワード設定/変更はこちら")
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ]),
          _hoisted_15
        ])
      ])
    ])
  ]))
}